module.exports = __webpack_public_path__ + "assets/img/bg.9529e61a.png";